import { defineComponent as H, cloneVNode as I, mergeProps as V, withDirectives as B, h as u, Transition as W, vShow as F, ref as c, inject as X, watch as y, toRef as C, computed as b, normalizeClass as w, nextTick as $, provide as O } from "vue";
import Y, { cardBasePropKeys as _ } from "./highrise1078.mjs";
import { NDialog as z } from "./highrise1179.mjs";
import { dialogPropKeys as G } from "./highrise1180.mjs";
import { drawerBodyInjectionKey as J } from "./highrise1088.mjs";
import { popoverBodyInjectionKey as Q } from "./highrise1449.mjs";
import { useDragModal as U } from "./highrise177.mjs";
import { modalInjectionKey as Z, modalBodyInjectionKey as ee } from "./highrise1166.mjs";
import { presetProps as te } from "./highrise1167.mjs";
import { getFirstSlotVNodeWithTypedProps as re } from "./highrise1228.mjs";
import { warn as oe } from "./highrise1064.mjs";
import ie from "./highrise1093.mjs";
import { FocusTrap as se } from "./highrise1395.mjs";
import le from "./highrise640.mjs";
import { keep as E } from "./highrise1097.mjs";
import { useLockHtmlScroll as ne } from "./highrise1491.mjs";
const ke = H({
  name: "ModalBody",
  inheritAttrs: !1,
  slots: Object,
  props: Object.assign(Object.assign({
    show: {
      type: Boolean,
      required: !0
    },
    preset: String,
    displayDirective: {
      type: String,
      required: !0
    },
    trapFocus: {
      type: Boolean,
      default: !0
    },
    autoFocus: {
      type: Boolean,
      default: !0
    },
    blockScroll: Boolean,
    draggable: {
      type: [Boolean, Object],
      default: !1
    }
  }, te), {
    renderMask: Function,
    // events
    onClickoutside: Function,
    onBeforeLeave: {
      type: Function,
      required: !0
    },
    onAfterLeave: {
      type: Function,
      required: !0
    },
    onPositiveClick: {
      type: Function,
      required: !0
    },
    onNegativeClick: {
      type: Function,
      required: !0
    },
    onClose: {
      type: Function,
      required: !0
    },
    onAfterEnter: Function,
    onEsc: Function
  }),
  setup(t) {
    const n = c(null), l = c(null), a = c(t.show), f = c(null), m = c(null), i = X(Z);
    let o = null;
    y(C(t, "show"), (e) => {
      e && (o = i.getMousePosition());
    }, {
      immediate: !0
    });
    const {
      stopDrag: s,
      startDrag: h,
      draggableRef: p,
      draggableClassRef: d
    } = U(C(t, "draggable"), {
      onEnd: (e) => {
        R(e);
      }
    }), g = b(() => w([t.titleClass, d.value])), P = b(() => w([t.headerClass, d.value]));
    y(C(t, "show"), (e) => {
      e && (a.value = !0);
    }), ne(b(() => t.blockScroll && a.value));
    function T() {
      if (i.transformOriginRef.value === "center")
        return "";
      const {
        value: e
      } = f, {
        value: r
      } = m;
      if (e === null || r === null)
        return "";
      if (l.value) {
        const v = l.value.containerScrollTop;
        return `${e}px ${r + v}px`;
      }
      return "";
    }
    function R(e) {
      if (i.transformOriginRef.value === "center" || !o || !l.value) return;
      const r = l.value.containerScrollTop, {
        offsetLeft: v,
        offsetTop: x
      } = e, q = o.y, K = o.x;
      f.value = -(v - K), m.value = -(x - q - r), e.style.transformOrigin = T();
    }
    function A(e) {
      $(() => {
        R(e);
      });
    }
    function L(e) {
      e.style.transformOrigin = T(), t.onBeforeLeave();
    }
    function N(e) {
      const r = e;
      p.value && h(r), t.onAfterEnter && t.onAfterEnter(r);
    }
    function S() {
      a.value = !1, f.value = null, m.value = null, s(), t.onAfterLeave();
    }
    function j() {
      const {
        onClose: e
      } = t;
      e && e();
    }
    function D() {
      t.onNegativeClick();
    }
    function M() {
      t.onPositiveClick();
    }
    const k = c(null);
    return y(k, (e) => {
      e && $(() => {
        const r = e.el;
        r && n.value !== r && (n.value = r);
      });
    }), O(ee, n), O(J, null), O(Q, null), {
      mergedTheme: i.mergedThemeRef,
      appear: i.appearRef,
      isMounted: i.isMountedRef,
      mergedClsPrefix: i.mergedClsPrefixRef,
      bodyRef: n,
      scrollbarRef: l,
      draggableClass: d,
      displayed: a,
      childNodeRef: k,
      cardHeaderClass: P,
      dialogTitleClass: g,
      handlePositiveClick: M,
      handleNegativeClick: D,
      handleCloseClick: j,
      handleAfterEnter: N,
      handleAfterLeave: S,
      handleBeforeLeave: L,
      handleEnter: A
    };
  },
  render() {
    const {
      $slots: t,
      $attrs: n,
      handleEnter: l,
      handleAfterEnter: a,
      handleAfterLeave: f,
      handleBeforeLeave: m,
      preset: i,
      mergedClsPrefix: o
    } = this;
    let s = null;
    if (!i) {
      if (s = re("default", t.default, {
        draggableClass: this.draggableClass
      }), !s) {
        oe("modal", "default slot is empty");
        return;
      }
      s = I(s), s.props = V({
        class: `${o}-modal`
      }, n, s.props || {});
    }
    return this.displayDirective === "show" || this.displayed || this.show ? B(u("div", {
      role: "none",
      class: `${o}-modal-body-wrapper`
    }, u(ie, {
      ref: "scrollbarRef",
      theme: this.mergedTheme.peers.Scrollbar,
      themeOverrides: this.mergedTheme.peerOverrides.Scrollbar,
      contentClass: `${o}-modal-scroll-content`
    }, {
      default: () => {
        var h;
        return [(h = this.renderMask) === null || h === void 0 ? void 0 : h.call(this), u(se, {
          disabled: !this.trapFocus,
          active: this.show,
          onEsc: this.onEsc,
          autoFocus: this.autoFocus
        }, {
          default: () => {
            var p;
            return u(W, {
              name: "fade-in-scale-up-transition",
              appear: (p = this.appear) !== null && p !== void 0 ? p : this.isMounted,
              onEnter: l,
              onAfterEnter: a,
              onAfterLeave: f,
              onBeforeLeave: m
            }, {
              default: () => {
                const d = [[F, this.show]], {
                  onClickoutside: g
                } = this;
                return g && d.push([le, this.onClickoutside, void 0, {
                  capture: !0
                }]), B(this.preset === "confirm" || this.preset === "dialog" ? u(z, Object.assign({}, this.$attrs, {
                  class: [`${o}-modal`, this.$attrs.class],
                  ref: "bodyRef",
                  theme: this.mergedTheme.peers.Dialog,
                  themeOverrides: this.mergedTheme.peerOverrides.Dialog
                }, E(this.$props, G), {
                  titleClass: this.dialogTitleClass,
                  "aria-modal": "true"
                }), t) : this.preset === "card" ? u(Y, Object.assign({}, this.$attrs, {
                  ref: "bodyRef",
                  class: [`${o}-modal`, this.$attrs.class],
                  theme: this.mergedTheme.peers.Card,
                  themeOverrides: this.mergedTheme.peerOverrides.Card
                }, E(this.$props, _), {
                  headerClass: this.cardHeaderClass,
                  "aria-modal": "true",
                  role: "dialog"
                }), t) : this.childNodeRef = s, d);
              }
            });
          }
        })];
      }
    })), [[F, this.displayDirective === "if" || this.displayed || this.show]]) : null;
  }
});
export {
  ke as default
};
